export const PENDING_STATUSES = new Set([
    'NEW',
    'PENDING',
    'PENDING - PRODUCTION INFO REQUIRED',
    'PENDING - MODIFICATIONS REQUIRED',
    'PENDING - UNDER LEGAL REVIEW',
    'PENDING - RELEASE NEEDED',
    'PENDING - LEGAL NEGOTIATION',
    'PENDING - LICENSOR APPROVAL NEEDED',
    'PENDING - UPDATED BY PRODUCTION',
    'PENDING - FONT REQUIRED'
]);


export const SnP_STATUSES = new Set([
    'APPROVAL PENDING',
    'APPROVED',
    'DEFERRED',
    'DENIED'
]);